import Grid from '@/global/components/ui/Grid'
import { Divider } from '@mui/material'
import { FormField } from 'global/components/Form'

export function DadosResponsavel() {
    return (
        <section id="dados-responsavel">
            <Divider sx={{ mb: 3, mt: 4, userSelect: 'none' }}>
                Dados do responsável
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormField
                        name="nomeResponsavel"
                        label="Nome do Responsável"
                        required
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField name="email" label="E-mail" required />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormField
                        name="cpfResponsavel"
                        label="CPF"
                        placeholder="000.000.000-00"
                        required
                        options={{
                            blocks: [3, 3, 3, 2],
                            delimiters: ['.', '.', '-'],
                        }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormField
                        name="telefoneResponsavel"
                        label="Telefone Responsável"
                        required
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR',
                        }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormField
                        name="telefone"
                        label="Telefone"
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR',
                        }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormField
                        name="celular"
                        label="Telefone 2"
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR',
                        }}
                    />
                </Grid>
            </Grid>
        </section>
    )
}
